import React from "react";
import { Button } from "@/components/ui/button";
import {
  type PaymentSelectionKey,
  toPaymentSelectionKey,
} from "@/services/student/checkout/checkout.interfaces";
import { usePaymentMethods } from "../payments/hooks/usePaymentMethods";
import {
  getPaymentMethodFallbackLabel,
  getPaymentProviderBadgeLabel,
  PAYMENT_CHANGE_METHOD_LABEL,
} from "./checkoutPaymentLabels";

interface CheckoutPaymentMethodRecapProps {
  selectedPaymentKey: PaymentSelectionKey | null;
  onChangeMethod: () => void;
}

export const CheckoutPaymentMethodRecap: React.FC<CheckoutPaymentMethodRecapProps> = ({
  selectedPaymentKey,
  onChangeMethod,
}) => {
  const { data: methods } = usePaymentMethods();

  const descriptor = selectedPaymentKey
    ? methods?.find(
        (method) => toPaymentSelectionKey(method.provider, method.method) === selectedPaymentKey
      )
    : undefined;

  const displayName = descriptor?.displayName ?? getPaymentMethodFallbackLabel(selectedPaymentKey);
  const providerLabel = getPaymentProviderBadgeLabel(selectedPaymentKey);

  return (
    <section
      id="payment-method-recap"
      className="rounded-xl border border bg-background"
      aria-labelledby="payment-method-recap-heading"
      aria-live="polite"
    >
      <div className="flex items-center justify-between gap-3 px-6 py-4">
        <div className="min-w-0">
          <p
            id="payment-method-recap-heading"
            className="text-xs font-medium text-text-secondary"
          >
            Forma escolhida
          </p>
          <div className="mt-1 flex flex-wrap items-center gap-2">
            <p className="font-semibold text-foreground">{displayName}</p>
            {providerLabel ? (
              <span className="rounded-full bg-surface-subtle px-2 py-0.5 text-xs font-medium text-text-secondary">
                {providerLabel}
              </span>
            ) : null}
          </div>
        </div>
        <Button
          type="button"
          variant="outline"
          onClick={onChangeMethod}
          className="min-h-[44px] shrink-0"
        >
          {PAYMENT_CHANGE_METHOD_LABEL}
        </Button>
      </div>
    </section>
  );
};
